//
import React from "react"
import PropTypes from "prop-types"

import { federalAndStates, localRegions } from "shared/imports/regionConstants"

import {
    // sorting functions
    enumValueSort,
} from "shared/search/containers/Filter/Filters"
import { enumGenericFilter } from "shared/search/containers/Filter/FilterCreators"

/** Result Type */
export const OfficialInOutboxTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
OfficialInOutboxTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    sortBy: PropTypes.func,
    enumGroups: PropTypes.array,
    regions: PropTypes.array,
}
OfficialInOutboxTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "officialTypeFilter",
    filterKey: "ph_minor_role_type",
    enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items(),
    enumGroups: Userdata.isOnlyFederalMode()
        ? DjangIO.app.person.newtypes.MinorRoleType.filter_groups.filter(
              (group) =>
                  ![
                      "Legislative",
                      "Staff",
                      "Legislative Staff",
                      "Leadership Staff",
                      "Executive Staff",
                      "Committee Staff",
                      "Campaign Staff",
                  ].includes(group.title),
          )
        : DjangIO.app.person.newtypes.MinorRoleType.filter_groups.filter(
              (group) =>
                  ![
                      "Staff",
                      "Legislative Staff",
                      "Leadership Staff",
                      "Executive Staff",
                      "Committee Staff",
                      "Campaign Staff",
                  ].includes(group.title),
          ),
    sortBy: enumValueSort,
    regions: federalAndStates.concat(localRegions),
}
